import * as React from 'react';
import {connect} from 'react-redux';
import * as FleetModule from 'Modules/FleetModule';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {withTranslation} from 'react-i18next';
import {ParentDetails, CustomProps, IParentDetailsProps} from 'components/Layout/DetailsSidebar/ParentDetails';
import * as Dictionary from 'Models/Dictionary';
import {PopupType} from "Models/EnumTypes/ViewManagementEnumTypes";
import {EnumTypes as PageEnumTypes} from "Modules/ViewManagementModule";
import {LinkHoc} from "components/Layout/DetailsSidebar/ContractListDetails";
import * as ContractModule from "Modules/ContractModule";
import * as UserModule from "Modules/UserModule";
import * as EnumTypes from '../../../Models/EnumTypes/ViewManagementEnumTypes';
import { appURL } from 'src/Connectors/_main';
import { fetchCarRouteHash } from 'src/Modules/CarRouteViewer/Services/CarRouteViewer.Service';

interface IP extends IParentDetailsProps {
    history: any;
    match: any;
}

type ConnectedP = {
    activeEl: VehiclesModule.Types.CarDto;
    user: UserModule.Types.UserDto;
};
type DispatchedP = {
    setActiveVehicle: () => void;
    showPopup: (popupData: ViewManagementModule.Types.Popup) => Function;
    t?: (key: string) => string;
    turnOnCar: (carId: number) => void;
    turnOffSim: (msisdn: string) => void;
    setActivePage: Function;
    setCurrentContractVin: Function;
};
type S = {};

class CarPreviewDetails extends ParentDetails<IP & ConnectedP & DispatchedP, S> {
    public getCustomProps(): CustomProps {
        const {activeEl} = this.props;
        return {
            ...(this.props as any),
            // setActiveEl: () => this.props.setActiveVehicle(),
            activeEl,
            extrnalRender: () => this.externalRender()
        };
    }

    private redirect = (type: 'diagnostic' | 'history' | 'alert' | 'turnOffCar') => {
        if (this.props.activeEl) {
            this.props.history.push(`${Dictionary.PageUrl.get(ViewManagementModule.EnumTypes.Page.CARS_MANAGEMENT)}/${this.props.activeEl.id}/${type}`);
        }
    };

    protected setEditContract = () => {
        if (!this.buttonIsDisabled()) {
            const {activeEl} = this.getCustomProps();
            this.props.history.push(`${Dictionary.PageUrl.get(PageEnumTypes.Page.CARS_MANAGEMENT)}/${activeEl.id}/edit-contract`);
        }
    };

    private setCurrentVin = () => {
        const {activeEl} = this.getCustomProps();
        this.props.setCurrentContractVin(activeEl?.vin);
    };

    private generateCarRouteExternalUrl = async () => {
        const res = await fetchCarRouteHash(this.props.activeEl.id);
        const {activeEl, showPopup} = this.props;
        console.log(res)
        if(res?.hash === '' || res?.hash === null || res?.hash === undefined) {
            showPopup({
                type: PopupType.EMPTY,
                template: EnumTypes.PopupTemplate.OK_TEMPLATE,
                confirmCallback: () => {
                    //ll 
                },
                extraContent: <span>Nie udało się wygenerować linku. Prosimy o kontakt z pomocą techniczną</span>
            });
            return;
        }
        if (activeEl) {
            // const {PopupType} = ViewManagementModule.EnumTypes;
            showPopup({
                type: PopupType.CAR_ROAD_URL_EXTERNAL,
                template: EnumTypes.PopupTemplate.OK_TEMPLATE,
                confirmCallback: () => {
                    //ll 
                },
                extraContent:<a className={"popup__description__link"} href={`${appURL}${Dictionary.PageUrl.get(PageEnumTypes.Page.CAR_ROUTE_VIEWER)}/${res.hash}`}>{appURL}{Dictionary.PageUrl.get(PageEnumTypes.Page.CAR_ROUTE_VIEWER)}/{res.hash}</a>
            });
        }
    }

    private externalRender() {
        const {t, activeEl, showPopup, turnOnCar, turnOffSim, setActivePage, user} = this.props;
        const classNameBtnState = activeEl ? '' : ' details-right__dashboard-item--disabled ';

        return (
            <>
                <div
                    className={`details-right__dashboard-item ${classNameBtnState}`}
                    onClick={() => this.redirect('history')}>
                    <div className={'details-right__dashboard-icon'}>
                        <img src={`/images/icons/calendar_blue.svg`} alt=""
                             className="details-right__dashboard-icon--mini"/>
                    </div>
                    <span>{t('carHistory')}</span>
                </div>
                <div
                    className={`details-right__dashboard-item ${classNameBtnState}`}
                    onClick={() => this.redirect('alert')}>
                    <div className={'details-right__dashboard-icon'}>
                        <img src={`/images/icons/alert.svg`} alt="" className="details-right__dashboard-icon--mini"/>
                    </div>
                    <span>{t('alertHistory')}</span>
                </div>
                <div
                    className={`details-right__dashboard-item ${classNameBtnState}`}
                    onClick={() => this.redirect('diagnostic')}>
                    <div className={'details-right__dashboard-icon'}>
                        <img src={`/images/icons/car.svg`} alt="" className="details-right__dashboard-icon--mini"/>
                    </div>
                    <span>{t('carDiagnostic')}</span>
                </div>

                <LinkHoc isActive={activeEl && activeEl.contractNumber && true}
                         pageType={PageEnumTypes.Page.CONTRACT_MANAGEMENT}
                         setActivePage={setActivePage}
                         testId={'menu-change-contract-number'}
                         onClickAction={this.setEditContract}>
                    <div className={'details-right__dashboard-icon'}>
                        <img src={`/images/icons/manual.svg`} alt="" className="details-right__dashboard-icon--mini"/>
                    </div>
                    <span>Zmień numer umowy</span>
                </LinkHoc>

                <LinkHoc isActive={activeEl && activeEl.contractNumber && true}
                         pageType={PageEnumTypes.Page.CONTRACT_MANAGEMENT}
                         setActivePage={setActivePage}
                         onClickAction={this.setCurrentVin}>
                    <div className={'details-right__dashboard-icon'}>
                        <img src={`/images/icons/fleet.svg`} alt="" className="details-right__dashboard-icon--mini"/>
                    </div>
                    <span>Przejdź do umowy</span>
                </LinkHoc>

                {
                    !activeEl?.turnOffDate ? <div
                        className={`details-right__dashboard-item ${activeEl ? '' : 'details-right__dashboard-item--disabled'}`}
                        onClick={() => this.redirect('turnOffCar')}>
                        <div className={'details-right__dashboard-icon'}>
                            <img src={`/images/icons/block_active.svg`} alt=""
                                 className="details-right__dashboard-icon--mini"/>
                        </div>
                        <span>{t('turnOffCar')}</span>
                    </div> : <div
                        className={`details-right__dashboard-item ${activeEl ? '' : 'details-right__dashboard-item--disabled'}`}
                        onClick={() => showPopup({
                            type: PopupType.CONFIRM_TURN_ON,
                            confirmCallback: async () => {
                                await turnOnCar(activeEl.id);
                            },
                            extraContent: <></>
                        })}>
                        <div className={'details-right__dashboard-icon'}>
                            <img src={`/images/icons/active_user.svg`} alt=""
                                 className="details-right__dashboard-icon--mini"/>
                        </div>
                        <span>{t('turnOnCarAgain')}</span>
                    </div>
                }

                {
                    (user && user.roleName === UserModule.UserEnumTypes.RoleName.ADMIN && activeEl?.msisdn) && <div
                        className={`details-right__dashboard-item ${activeEl ? '' : 'details-right__dashboard-item--disabled'}`}
                        onClick={() => showPopup({
                            type: PopupType.CONFIRM_TURN_OFF_SIM,
                            confirmCallback: async () => {
                                await turnOffSim(activeEl.msisdn);
                            },
                            extraContent: <></>
                        })}>
                        <div className={'details-right__dashboard-icon'}>
                            <img src={`/images/icons/priority_red.svg`} alt=""
                                 className="details-right__dashboard-icon--mini"/>
                        </div>
                        <span>{t('turnOffSim')}</span>
                    </div>
                }

{
                    (user && user.roleName === UserModule.UserEnumTypes.RoleName.ADMIN) && <div
                        className={`details-right__dashboard-item ${activeEl ? '' : 'details-right__dashboard-item--disabled'}`}
                        onClick={() => this.generateCarRouteExternalUrl()}>
                        <div className={'details-right__dashboard-icon'}>
                            <img src={`/images/icons/arrow.svg`} alt=""
                                 className="details-right__dashboard-icon--mini"/>
                        </div>
                        <span>Wygeneruj link od trasy bez autoryzacji</span>
                    </div>
                }
            </>
        );
    }

}

function mapStateToProps(state: any): ConnectedP {
    return {
        activeEl: state.vehiclesStore.activeVehicleDetails,
        user: state.userStore?.user
    };
}

function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        setActiveVehicle: () => dispatch(VehiclesModule.Actions.setDetailsForVehile(null)),
        showPopup: (popupData: ViewManagementModule.Types.Popup) => dispatch(ViewManagementModule.Actions.showPopup(popupData)),
        turnOnCar: (carId: number) => dispatch(VehiclesModule.Actions.turnOnCar(carId)),
        turnOffSim: (msisdn: string) => dispatch(VehiclesModule.Actions.turnOffSim(msisdn)),
        setActivePage: (page: ViewManagementModule.Types.Page) => dispatch(ViewManagementModule.Actions.setActivePage(page)),
        setCurrentContractVin: (currentVin) => dispatch(ContractModule.Actions.setCurrentContractVin(currentVin))
    };
}

export default withTranslation('carDetails')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(CarPreviewDetails) as React.ComponentType<any>);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/CarPreviewDetails.tsx